import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsPyupComponent } from './simple-icons-pyup.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsPyupComponent ],
    exports:      [ SimpleIconsPyupComponent ],
    bootstrap:    []
})
export class SimpleIconsPyupModule {}
